module.exports = __webpack_public_path__ + "static/img/YORK教室 _1.407497a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK教室 _1.png
// module id = ZpdK
// module chunks = 0